import {theme} from "Theme";

import {isOpenExtension, PERMIT_EXTENSION_STATUS} from "./permitExtensionStatus";
import {DateUtil} from "base/format/utilities";

import {TextLink} from "base/navigation/components";
import {PermitTypeAndDatesTags, PermitTypeTags} from "permit/presentational";

import Typography from "@mui/material/Typography";

export function usePermitExtensionsTable() {
    const tableColumns = [
        {
            id: "code",
            label: "Autorização",
            width: 10,
            formatFunction: item => {
                return (
                    <TextLink
                        text={item?.permit?.code}
                        to={`/permits/extensions/list/${item?.id}/summary`}
                        textStyle={{fontSize: "inherit"}}
                    />
                );
            },
        },
        {
            id: "status",
            label: "Estado",
            width: 25,
            formatFunction: item => (
                <Typography
                    color={
                        item.status === PERMIT_EXTENSION_STATUS.not_approved
                            ? theme.palette.error.dark
                            : "inherit"
                    }
                    fontSize={theme.typography.fontSize}
                >
                    {item.status}
                </Typography>
            ),
        },
        {
            id: "application_date",
            label: "Data de solicitação",
            width: 15,
            formatFunction: item => DateUtil.formatDate(item.application_date),
        },
        {
            id: "holder__name",
            label: "Titular",
            width: 20,
            formatFunction: item => (
                <TextLink
                    text={item?.holder?.name}
                    to={`/holders/all/list/${item.holder?.id}/summary`}
                    textStyle={{fontSize: "inherit"}}
                />
            ),
        },
        {
            id: "district",
            label: "Distrito",
            width: 10,
        },
        {
            id: "types",
            label: "Guias prorrogadas",
            width: 20,
            formatFunction: item => {
                return <PermitTypeTags types={item?.types} />;
            },
            disableSorting: true,
        },
    ];

    const tableColumnsSummary = [
        {
            id: "status",
            label: "Estado",
            width: 25,
            formatFunction: item =>
                isOpenExtension(item.status) ? (
                    <TextLink
                        text={item.status}
                        to={`/permits/extensions/list/${item?.id}/summary`}
                        textStyle={{fontSize: "inherit"}}
                    />
                ) : (
                    <Typography
                        color={
                            item.status === PERMIT_EXTENSION_STATUS.not_approved
                                ? theme.palette.error.dark
                                : "inherit"
                        }
                        fontSize={theme.typography.fontSize}
                    >
                        {item.status}
                    </Typography>
                ),
        },
        {
            id: "type",
            label: "Tipo",
            width: 20,
            formatFunction: item => (item.isTotal ? "Total" : "Parcial"),
        },
        {
            id: "application_date",
            label: "Data de solicitação",
            width: 15,
            formatFunction: item => DateUtil.formatDate(item.application_date),
        },
        {
            id: "on_date",
            label: "Data de aprovação",
            width: 15,
            formatFunction: item => DateUtil.formatDate(item.on_date),
        },
        {
            id: "types",
            label: "Prorrogação",
            width: 25,
            formatFunction: item => <PermitTypeAndDatesTags item={item} />,
        },
    ];

    return {tableColumns, tableColumnsSummary};
}
